// ROTAS PARA O REACT ROUTER
//declara as páginas do portal

//não esqueça da verificação de login

import React, { useEffect, useState } from "react";
import { Route, BrowserRouter, Routes } from "react-router-dom";

import Login from "../pages/Login/index";
import Home from "../pages/Home/index";
import Agenda from "../pages/Agenda/index";
import Realizados from "../pages/Realizados/index";
import {
    AparelhosAutonomos,
    InspecaoDeFrente,
    AnaliseDeRisco,
    MascaraDeFuga,
    Diphoterine,
    ViaturaDeEmergencia,
    Birutas,
    Rotas,
    Veiculos,
    Rtc,
    SalaDaBrigada
} from "../pages/Realizados/componentesRenderizados";

import { AparelhosAutonomosInfo } from "../pages/Realizados/componentesRenderizados/componentesInfo/aparelhosAutonomosInfo";
import { AnaliseInfo } from "../pages/Realizados/componentesRenderizados/componentesInfo/analiseInfo";
import { DiphoterineInfo } from "../pages/Realizados/componentesRenderizados/componentesInfo/diphoterineInfo";
import { InspecaoFrenteInfo } from "../pages/Realizados/componentesRenderizados/componentesInfo/inspecaoFrenteInfo";
import { MascaraInfo } from "../pages/Realizados/componentesRenderizados/componentesInfo/mascaraInfo";
import { RTCInfo } from "../pages/Realizados/componentesRenderizados/componentesInfo/rtcInfo";
import { SalaInfo } from "../pages/Realizados/componentesRenderizados/componentesInfo/salaInfo";
import { VeiculosInfo } from "../pages/Realizados/componentesRenderizados/componentesInfo/veiculosInfo";
import { ViaturaInfo } from "../pages/Realizados/componentesRenderizados/componentesInfo/viaturaInfo";
import { BirutasInfo } from "../pages/Realizados/componentesRenderizados/componentesInfo/birutasInfo";
import { RotasInfo } from "../pages/Realizados/componentesRenderizados/componentesInfo/rotasInfo";


import { isExpired } from "react-jwt";
import Mapa from "../pages/Mapa";
import Indicadores from "../pages/Indicadores";

const Router = () => {
    const [token, setToken] = useState(
        JSON.parse(sessionStorage.getItem("token"))
    );

    const validateToken = (t) => {
        return !isExpired(t);
    };

    useEffect(() => {
        validateToken();
    }, [token]);

    return (
        <BrowserRouter>
            <Routes>
                {/* login */}
                <Route
                    path="/"
                    element={<Login token={token} setToken={setToken} />}
                />

                {/* home */}
                <Route
                    path="/home"
                    element={
                        validateToken(token) ? (
                            <Home token={token} />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                />

                {/* agenda */}
                <Route
                    path="/agenda"
                    element={
                        validateToken(token) ? (
                            <Agenda token={token} popup={null} />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                />

                {/* rotas */}
                <Route
                    path="/agenda/rotas"
                    element={
                        validateToken(token) ? (
                            <Agenda token={token} popup="rotas" />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                />

                {/* tecnicos */}
                <Route
                    path="/agenda/tecnicos"
                    element={
                        validateToken(token) ? (
                            <Agenda token={token} popup="tecnicos" />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                />

                {/* Mapa */}
                <Route
                    path="/mapa"
                    element={
                        validateToken(token) ? (
                            <Mapa token={token} popup="mapa" />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                />

                {/* Indicadores */}
                <Route
                    path="/indicadores"
                    element={
                        validateToken(token) ? (
                            <Indicadores token={token} popup="indicadores" />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                />

                {/* -------------- Realizados ---------------- */}
                <Route
                    path="/realizados"
                    element={
                        validateToken(token) ? (
                            <Realizados token={token} />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                />

                <Route
                    path="/realizados/aparelhos"
                    element={
                        validateToken(token) ? (
                            <AparelhosAutonomos token={token} />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                />

                <Route
                    path="/realizados/inspecao"
                    element={
                        validateToken(token) ? (
                            <InspecaoDeFrente token={token} />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                />

                <Route
                    path="/realizados/analise"
                    element={
                        validateToken(token) ? (
                            <AnaliseDeRisco token={token} />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                />

                <Route
                    path="/realizados/mascara"
                    element={
                        validateToken(token) ? (
                            <MascaraDeFuga token={token} />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                />

                <Route
                    path="/realizados/diphoterine"
                    element={
                        validateToken(token) ? (
                            <Diphoterine token={token} />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                />

                <Route
                    path="/realizados/viatura"
                    element={
                        validateToken(token) ? (
                            <ViaturaDeEmergencia token={token} />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                />

                <Route
                    path="/realizados/birutas"
                    element={
                        validateToken(token) ? (
                            <Birutas token={token} />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                />

                <Route
                    path="/realizados/rotas"
                    element={
                        validateToken(token) ? (
                            <Rotas token={token} />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                />

                <Route
                    path="/realizados/veiculos"
                    element={
                        validateToken(token) ? (
                            <Veiculos token={token} />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                />

                <Route
                    path="/realizados/rtc"
                    element={
                        validateToken(token) ? (
                            <Rtc token={token} />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                />

                <Route
                    path="/realizados/sala"
                    element={
                        validateToken(token) ? (
                            <SalaDaBrigada token={token} />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                />

                <Route
                    path="/realizados/aparelhos/autonomos/:id"
                    element={
                        validateToken(token) ? (
                            <AparelhosAutonomosInfo token={token} />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                />

                <Route
                    path="/realizados/inspecao/:id"
                    element={
                        validateToken(token) ? (
                            <InspecaoFrenteInfo token={token} />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                />

                <Route
                    path="/realizados/analise/:id"
                    element={
                        validateToken(token) ? (
                            <AnaliseInfo token={token} />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                /> 

                <Route
                    path="/realizados/mascara/:id"
                    element={
                        validateToken(token) ? (
                            <MascaraInfo token={token} />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                /> 

                <Route
                    path="/realizados/diphoterine/:id"
                    element={
                        validateToken(token) ? (
                            <DiphoterineInfo token={token} />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                /> 

                <Route
                    path="/realizados/viatura/:id"
                    element={
                        validateToken(token) ? (
                            <ViaturaInfo token={token} />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                /> 

                <Route
                    path="/realizados/birutas/:id"
                    element={
                        validateToken(token) ? (
                            <BirutasInfo token={token} />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                /> 

                <Route
                    path="/realizados/rotas/:id"
                    element={
                        validateToken(token) ? (
                            <RotasInfo token={token} />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                /> 

                <Route
                    path="/realizados/veiculos/:id"
                    element={
                        validateToken(token) ? (
                            <VeiculosInfo token={token} />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                /> 

                <Route
                    path="/realizados/rtc/:id"
                    element={
                        validateToken(token) ? (
                            <RTCInfo token={token} />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                /> 

                <Route
                    path="/realizados/sala/:id"
                    element={
                        validateToken(token) ? (
                            <SalaInfo token={token} />
                        ) : (
                            <Login token={token} setToken={setToken} />
                        )
                    }
                /> 
            </Routes>
        </BrowserRouter>
    );
};

export default Router;
